import React from 'react';
import moment from 'moment-timezone';
import i18next from 'i18next';


class PatientPresenter {
  constructor(patientData) {
    this.uuid = patientData.uuid;
    this.fullName = patientData.full_name;
    this.gender = patientData.gender;
    this.email = patientData.email;
    this.mobileNumber = patientData.mobile_number;
    this.externalId = patientData.external_id;
    this.dob = patientData.dob;
    this.location = patientData.location;
    this.link = patientData.link;
    this.comments = patientData.comments;
    this.completedSessionsCount = patientData.completed_sessions_count;
    this.completedCallsCount = patientData.completed_calls_count;
    this.lastSessionCompletedAt = patientData.last_session_completed_at;

  }

  getUUID() {
    return this.uuid;
  }

  getFullName() {
    return this.fullName;
  }

  getGender() {
    if (!this.gender) return null;
    return i18next.t(`patient_form.fields.gender_${this.gender}`);
  }

  getGenderSubject() {
    if (!this.gender) return null;
    return i18next.t(`patient_form.fields.gender_${this.gender}_subject`);
  }

  getGenderValue() {
    return this.gender;
  }

  getEmail() {
    return this.email;
  }

  getMobileNumber() {
    return this.mobileNumber;
  }

  getExternalId() {
    return this.externalId;
  }

  // Returns the date of birth in a formatted string.
  getDOB(format = 'D MMM YYYY', locale = 'es') {
    if (!this.dob) return '';

    const dobMoment = moment.utc(this.dob).locale(locale);
    const formattedDate = dobMoment.format(format);

    return `${formattedDate} (${this.getAge()})`;
  }

  getAge() {
    if (!this.dob) return '';

    const dobMoment = moment.utc(this.dob);
    return dobMoment.fromNow(true); // e.g., "43 años"
  }

  getDemographics() {
    const parts = [];
    if (this.gender) {
      parts.push(this.getGenderSubject());
    }
    if (this.dob) {
      parts.push(this.getAge());
    }
    if (parts.length < 2 && this.location) {
      parts.push(this.location);
    }
    return parts.slice(0, 2).join(', ');
  }

  getLocation() {
    return this.location;
  }

  getLink() {
    return this.link;
  }

  getLinkElement() {
    if (!this.link) return '';

    const truncated =
      this.link.length > 40
        ? `${this.link.slice(0, 37)}...`
        : this.link;

    return (
      <a
        href={this.link}
        target="_blank"
        rel="noopener noreferrer"
        title={this.link}
      >
        {truncated}
      </a>
    );
  }

  getComments() {
    return this.comments;
  }

  getCompletedSessionsCount() {
    return this.completedSessionsCount;
  }

  getCompletedCallsCount() {
    return this.completedCallsCount;
  }
}

export default PatientPresenter;